$(window).on('load', () => {
  var mySwiper = document.querySelectorAll('.swiper-container');
  if (mySwiper) {
    mySwiper.forEach((slider) => {
      new Swiper(slider, {
        effect: 'slide',
        speed: 700,
        slidesPerView: 1,
        loop: true,
        pagination: {
          el: slider.querySelector('.swiper-pagination'),
          clickable: true,
          type: 'bullets',
        },
        navigation: {
          nextEl: slider.querySelector('.swiper-button-next'),
          prevEl: slider.querySelector('.swiper-button-prev'),
        },
      });
    });
  }

  const sliderSelect = document.querySelector('.cover-shop-navigation select');
  if (sliderSelect) {
    // console.log(sliderSe / lect);
    sliderSelect.addEventListener('change', function () {
      const dataSlider = this.value;
      window.location.href = dataSlider;
    });
  }

  const shopSelect = document.querySelectorAll('.shop-navigation select');
  if (shopSelect.length) {
    const shopSelectColor = document.querySelector('.shop-navigation .color');
    const shopSelectColection = document.querySelector(
      '.shop-navigation .colection'
    );
    shopSelect.forEach((element) => {
      element.addEventListener('change', function () {
        let link = '';
        if (shopSelectColor.value !== 'all') {
          link = shopSelectColection.value + shopSelectColor.value;
        } else {
          link = shopSelectColection.value;
        }
        window.location.href = link;
      });
    });
  }

  const navScroll = () => {
    let scrollpos = window.scrollY;
    const header = document.getElementById('header');
    if (scrollpos > 30) {
      header.classList.add('scroll');
    } else {
      header.classList.remove('scroll');
    }
  };

  const nav = () => {
    const burger = document.querySelector('.burger');
    const nav = document.querySelector('.navigation-mobile');
    const navLi = document.querySelectorAll('.navigation-mobile li');
    const navLinks = document.querySelectorAll('.navigation-mobile li a');
    const webBody = document.getElementsByTagName('body')[0];

    burger.addEventListener('click', () => {
      nav.classList.toggle('active');
      burger.classList.toggle('close');
      webBody.classList.toggle('overflow');

      navLi.forEach((link, index) => {
        if (link.style.animation) {
          link.style.animation = '';
        } else {
          link.style.animation = `navLinksFade 0.5s forwards  ${
            index / 7 + 0.25
          }s`;
        }
      });
    });

    navLinks.forEach((link, index) => {
      link.addEventListener('click', () => {
        nav.classList.toggle('active');
        burger.classList.toggle('close');
        webBody.classList.toggle('overflow');

        navLi.forEach((l) => {
          l.style.animation = '';
        });
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.keyCode === 27) {
        nav.classList.toggle('active');
        burger.classList.toggle('close');
        webBody.classList.toggle('overflow');

        navLi.forEach((l) => {
          l.style.animation = '';
        });
      }
    });
  };

  window.addEventListener('scroll', navScroll);
  nav();

  const bodyClassHome = document.body.classList.contains('home');
  const bodyClassCategory =
    document.body.classList.contains('woocommerce-active');

  if (bodyClassHome === true) {
    ScrollTrigger.matchMedia({
      '(min-width: 768px)': function () {
        gsap.to('.grid-photo-head .thumbnail', {
          yPercent: -20,
          ease: 'ease',
          scrollTrigger: {
            trigger: '.grid-photo-item',
            scrub: true,
          },
        });
        gsap.to('.grid-photo-item-1 .thumbnail', {
          yPercent: -50,
          ease: 'ease',
          scrollTrigger: {
            trigger: '.grid-photo-item',
            scrub: true,
          },
        });
        gsap.to('.grid-photo-item-2 .thumbnail', {
          yPercent: -60,
          ease: 'ease',
          scrollTrigger: {
            trigger: '.grid-photo-item-1',
            scrub: true,
          },
        });
        gsap.to('.grid-photo-item-3 .thumbnail', {
          yPercent: -30,
          ease: 'ease',
          scrollTrigger: {
            trigger: '.grid-photo-item-2',
            scrub: true,
          },
        });
        gsap.to('.grid-photo-item-4 .thumbnail', {
          yPercent: -40,
          ease: 'ease',
          scrollTrigger: {
            trigger: '.grid-photo-item-2',
            scrub: true,
          },
        });
        gsap.to('.grid-photo-item-5 .thumbnail', {
          yPercent: -10,
          ease: 'ease',
          scrollTrigger: {
            trigger: '.grid-photo-item-4',
            scrub: true,
          },
        });

        gsap.to('#showroom h2', {
          yPercent: 150,
          ease: 'power1',
          scrollTrigger: {
            trigger: '#showroom',
            scrub: true,
          },
        });
      },
    });
  }
});
console.log('end');
